import { getRaceNotifications } from "../client/notifications/notifications";
import { getJwtToken } from "../components/RWebView/Utils";

/**
 * Fetches race notification registrations for the given races
 *
 * Checks if there is a valid JWT token first, if not, returns early
 *
 * @param {Array<{ id: number }>} races - Array of race objects with an `id` property
 * @returns {Promise<number[] | undefined>} Array of race notification registration IDs, or undefined if no token or races provided
 */

export async function fetchRaceNotifications(races) {
  try {
    const token = await getJwtToken();
    if (!token) return;
    if (!races) return;

    const raceIds = races.map((race) => race.id);
    const response = await getRaceNotifications(raceIds);

    return response.registrations;
  } catch (error) {}
}
